var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 3.583c0-.566.2-1.025.592-1.391.391-.367.908-.55 1.533-.55.625 0 1.117.183 1.5.541.392.375.592.859.592 1.45 0 .542-.192.992-.575 1.35-.392.375-.909.559-1.55.559h-.017c-.617 0-1.117-.184-1.5-.559-.383-.375-.575-.841-.575-1.4Zm.217 14.784V7.083h3.75v11.284h-3.75Zm5.825 0h3.75v-6.3c0-.392.041-.7.133-.909.158-.383.4-.708.717-.975.325-.266.725-.4 1.208-.4 1.258 0 1.892.85 1.892 2.55v6.034h3.75V11.9c0-1.667-.392-2.933-1.184-3.792-.791-.858-1.833-1.291-3.125-1.291-1.45 0-2.583.625-3.391 1.875v.033h-.017l.017-.033V7.083h-3.75c.025.359.033 1.484.033 3.359s-.008 4.525-.033 7.925Z",
    fill: "#0A66C2"
  })));
};
export default SvgLinkedIn;